import gql from 'graphql-tag'
import { pathRegistrationFields, userFields } from '../user/user.query';
import { clientFields } from '../client/client.query';

export const pathFields = gql`
fragment pathFields on Path { 
  id
  streaks
  userChapter
  names
  currentChapter{       
    id
    name
    position
  
  currentStep{        
    position
               stepStatus
               originalStep
               chapterStepIndex
               step {
                   id
                   title
                   description
                   image
      }
    }
  }
  pathGroup {
    id
    name
    allowMultipleLogin
    enabledAttributes
  }
  enabledAttributes
  name
  daysOfTheWeek
  logoImage
  signupEmail
  daysOfContent
  starts
  ends
  colours
  names
  enabledAttributes
  language
  createdAt
  updatedAt
  enabled
  pathImage
  isPathCompleted
  isKyperPathCompleted
  deselectedChapters
  kyperChapters {
     id
     name
     position
     steps {
      stepStatus
       position
       originalStep
       step {
         id
         title
         description
         image
       }
       stepVersion {
         id
         versionNumber
         contentSummary
       }
       screens {
         id
         screenType
         position
         screenContents {
           id
           contentType
           content
           isCompleted
           userResponse
           actionPoints
           tool {      
              id
               name
               s3Path
               imageUrl
           }
         }
         assets {
           id
           assetType
           url
         }
       }
     }
   }
 }
`;


export const multipleSignInByFormV2 = gql`
mutation multipleSignInByFormV2(
 $email: String!, $password: String!, $pathGroupId: Int, $pathId: Int, $changePath: Boolean, $fromMobile: Boolean
) {
 multipleSignInByFormV2(
   email: $email, password: $password, pathGroupId: $pathGroupId, pathId: $pathId, changePath: $changePath, fromMobile: $fromMobile
 ) {
   token
   scheduleDay
   user {
      ...userFields
    }
    client {
      ...clientFields
    }
    path {
      ...pathFields
    }
    pathCount
    pathRegistration {
      ...pathRegistrationFields
    }
    allContentCompleted
    expiredOrRemoved
}
}
${userFields}
${clientFields}
${pathFields}
${pathRegistrationFields}
`;

export const multipleSignInByTokenV2 = gql`
mutation multipleSignInByTokenV2($token: String!) {
 multipleSignInByTokenV2(token: $token) {
   result
   pathCount
   showCloseoutSurvey
   allContentCompleted
   scheduleDay
   user {
      ...userFields
    }
    client {
      ...clientFields
    }
    path {
      ...pathFields
    }
    pathCount
    pathRegistration {
      ...pathRegistrationFields
    }
}
}
${userFields}
${clientFields}
${pathFields}
${pathRegistrationFields}
`;
export const validateDeletion1 = gql`
mutation multipleSignInByFormV2(
  $email: String!, $password: String!, $pathGroupId: Int, $pathId: Int, $changePath: Boolean, $fromMobile: Boolean
) {
  multipleSignInByFormV2(
    email: $email, password: $password, pathGroupId: $pathGroupId, pathId: $pathId, changePath: $changePath, fromMobile: $fromMobile
  ) {
    token
    user {
      ...userFields
    }
    scheduleDay
    allContentCompleted
    expiredOrRemoved
  }
}
${userFields}
`;
export const multipleSignInBySsoV2 = gql`
 mutation multipleSignInBySsoV2($email: String!, $ssoUid: String!, $isSso: Boolean, $changePath: Boolean, $fromMobile: Boolean, $pathGroupId: Int!, $pathId: Int!, $ssoProvider: String!) {
  multipleSignInBySsoV2(email: $email,
   ssoUid: $ssoUid,
   isSso: $isSso,
   changePath: $changePath,
   fromMobile: $fromMobile,
   pathGroupId: $pathGroupId,
   pathId: $pathId,
   ssoProvider: $ssoProvider) {
   token
   pathCount
   showCloseoutSurvey
   scheduleDay
   allContentCompleted
   user {
      ...userFields
    }
    client {
      ...clientFields
    }
    path {
      ...pathFields
    }
    pathCount
    pathRegistration {
      ...pathRegistrationFields
    }
   
}
}
${userFields}
${clientFields}
${pathFields}
${pathRegistrationFields}
`;